'use client'

import { intersection } from 'lodash'

import {
  AdditionalTransactionAction,
  ApplicableTransactionAction,
} from '@marketplace-web/messaging/conversation-messaging-data'
import { useConversationContext } from '@marketplace-web/messaging/conversation-providers-feature'

const useTransactionActions = () => {
  const { conversation } = useConversationContext()

  const applicableTransactionActions = intersection(
    conversation?.transaction?.availableActions,
    Object.values(ApplicableTransactionAction),
  ) as Array<ApplicableTransactionAction>

  const additionalTransactionActions = intersection(
    conversation?.transaction?.availableActions,
    Object.values(AdditionalTransactionAction),
  ) as Array<AdditionalTransactionAction>

  return { applicableTransactionActions, additionalTransactionActions }
}

export default useTransactionActions
